import { LoadingOverlay, Modal } from "@dehub/theme";
import { useRef, useState } from "react";
import useSwr from "swr";
import { GeneralApi } from "@/apis";
import { RegisterShell } from "./components/RegisterShell";
import { VerifyPanel } from "./components/VerifyPanel";
import { RegisterForm } from "./components/forms/register-form";

export function RegisterPage() {
  const [action, setAction] = useState<any[]>([]);
  const refGeneral = useRef<any>(null);

  const { data: initData, isLoading } = useSwr(`pub/init/general`, async () => await GeneralApi.initPub(), {
    fallbackData: { partnerTypes: [] },
  });

  if (isLoading) return <LoadingOverlay visible />;

  return (
    <RegisterShell>
      <RegisterForm ref={refGeneral} initData={initData} setAction={setAction} />

      <Modal
        size={500}
        title={false}
        withCloseButton={false}
        centered
        opened={action[0] === "verify"}
        onClose={() => {}}
        padding={0}
        radius="md">
        <VerifyPanel action={action} setAction={setAction} />
      </Modal>
    </RegisterShell>
  );
}
